import { sameId } from '../../../shared/api/wire'
import type { MoveWayVm, RmkVm } from './types'

/**
 * Каким кодом переносить работу из другой вкладки (К-120) — решение модели, экран его только рисует:
 * - `none` — работы нет или она идёт под своим именем: кода нет;
 * - `reading` — список кассиров нашей системы ещё читается: неизвестно, чей код спрашивать, перенос ждёт;
 * - `failed` — список прочитать не удалось: перенос ждёт перечтения (личный код, введённый как код кабинета, копил бы неверные попытки кода кассира
 *   источника);
 * - `cabinet` — кассир работы не связан с кассиром нашей системы (или окно без кассиров нашей системы): код кассира кабинета;
 * - `own` — связан: личный код этого кассира нашей системы. Кассир источника связан не больше чем с одним кассиром нашей системы, поэтому
 *   связь ищется по кассиру работы, а не по кассиру нашей системы (у одного кассира нашей системы в кабинете бывает несколько связей).
 */
export function moveWayOf(vm: Pick<RmkVm, 'mine' | 'ownCashiers'>): MoveWayVm {
  const cashierId = vm.mine?.cashierId ?? null
  if (cashierId === null) return { kind: 'none' }
  const own = vm.ownCashiers
  if (own === undefined) return { kind: 'cabinet' }
  const status = own.query.status
  if (status === 'idle' || status === 'loading') return { kind: 'reading', query: own.query }
  if (status !== 'ready' && status !== 'empty') return { kind: 'failed', query: own.query }
  const linked = own.items.find((item) => sameId(item.sourceCashierId, cashierId))
  return linked === undefined ? { kind: 'cabinet' } : { kind: 'own', own: linked }
}
